import {
  mapArtistGenreType,
  mapArtistType,
  mapOrganizationUnitType,
  useFindAllOrganizationUnitsSuspense,
  useFindArtistGenresSuspense,
  useFindArtistSuspense,
} from '@api';
import {
  EditActionIcon,
  TouringCard,
  TouringCardActions,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
} from '@common';
import { usePermissionContext } from '@hypeit-gmbh/hypeit-ui-core';
import { Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/artists/$id.general';
import { EditArtistForm, GeneralInformationTable } from './components';

export const ArtistGeneralInformation: React.FC = () => {
  const { t } = useTranslation('artistDetailsGeneral');
  const { id } = Route.useParams();
  const [opened, { open: openModal, close: closeModal }] = useDisclosure(false);
  const { data: artist } = useFindArtistSuspense(id, {
    query: { select: (data) => mapArtistType(data.data) },
  });
  const { data: artistGenres } = useFindArtistGenresSuspense({
    query: {
      select: (data) => data.data.map(mapArtistGenreType),
    },
  });
  const { data: organizationUnits } = useFindAllOrganizationUnitsSuspense({
    query: {
      select: (data) => data.data.map(mapOrganizationUnitType),
    },
  });
  const { hasPermission } = usePermissionContext();
  const userCanEditArtist = hasPermission({
    permission: 'ARTISTS_GENERAL',
    action: 'WRITE',
  });

  return (
    <>
      <TouringCard data-testid="artist-general-information-card">
        <TouringCardHeader>
          <TouringCardTitle>{t('GENERAL_INFORMATION.TITLE')}</TouringCardTitle>
          <TouringCardActions>
            {userCanEditArtist && <EditActionIcon onClick={openModal} />}
          </TouringCardActions>
        </TouringCardHeader>
        <TouringCardSection>
          <GeneralInformationTable
            artist={artist}
            organizationUnits={organizationUnits}
          />
        </TouringCardSection>
      </TouringCard>
      <Modal
        opened={opened}
        onClose={closeModal}
        size="md"
        title={t('EDIT_ARTIST_MODAL.TITLE')}
      >
        <EditArtistForm
          artist={artist}
          artistId={id}
          artistGenres={artistGenres}
          onClose={closeModal}
        />
      </Modal>
    </>
  );
};
